<div class="auth-card">

  <!-- Logo -->
  <div class="auth-logo">
    <img src="assets/style-sauvage_only_logo-removebg.png" alt="Logo Délice Éternel">
    <span class="auth-brand">Délice Éternel</span>
  </div>

  <h2 class="fp-title">Mot de passe oublié</h2>

  @if (!success) {
    <p class="fp-hint">
      Saisissez votre adresse e-mail et nous vous enverrons un lien pour réinitialiser votre mot de passe.
    </p>

    <form class="auth-form" (ngSubmit)="submit()">
      <div class="form-field">
        <label class="field-label">Adresse e-mail</label>
        <input
          class="field-input"
          type="email"
          [formControl]="email"
          placeholder="votre@email.com"
          autocomplete="email">
        @if (email.invalid && email.touched) {
          <span class="field-error">Adresse e-mail invalide</span>
        }
      </div>

      @if (socialProvider) {
        <div class="fp-social-warn">
          <i class="fas fa-info-circle"></i>
          Votre compte est lié à <strong>{{ socialProvider }}</strong>.
          Connexion en cours…
        </div>
      }

      @if (error) {
        <span class="auth-error">{{ error }}</span>
      }

      @if (!loading) {
        <button class="auth-btn" [disabled]="email.invalid" type="submit">
          Envoyer le lien
        </button>
      }
      @if (loading) {
        <button class="auth-btn auth-btn--loading" disabled type="button">
          <i class="fa fa-spinner fa-spin"></i>&nbsp;Envoi…
        </button>
      }
    </form>
  }

  @if (success) {
    <div class="auth-success fp-success">
      <i class="fas fa-envelope-open-text fp-success__icon"></i>
      <p>Un e-mail de réinitialisation a été envoyé à <strong>{{ email.value }}</strong>.</p>
      <p class="fp-success__hint">Vérifiez votre boîte de réception (et vos spams).</p>
    </div>
  }

  <div class="fp-back">
    <a routerLink="/auth/signin">← Retour à la connexion</a>
  </div>

</div>
